module.exports = __webpack_public_path__ + "img/v3-note.d43d4005.svg";